import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import ProductList from './pages/ProductList';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Cart from './pages/Cart';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import AdminPanel from './pages/AdminPanel';
import ProductDetail from './pages/ProductDetail';
import SearchResults from './pages/SearchResults';
import Checkout from './pages/Checkout';
import OrderSuccess from './pages/OrderSuccess';
import PaymentFailed from './pages/PaymentFailed';
import TermsOfService from './pages/TermsOfService';
import DistanceSalesAgreement from './pages/DistanceSalesAgreement';
import KVKKPolicy from './pages/KVKKPolicy';
import AboutPage from './pages/AboutPage';
import Contact from './pages/Contact';
import EmailVerification from './pages/EmailVerification';
import VerificationPending from './pages/VerificationPending';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <CartProvider>
        <Router>
          <ScrollToTop />
          <div className="App" style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            minHeight: '100vh' 
          }}>
            <Navbar />
            
            {/* Main content - flex: 1 ile footer'ı aşağı iter */}
            <main style={{ flex: 1 }}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/urunler" element={<ProductList />} />
                <Route path="/urun/:slug" element={<ProductDetail />} />
                <Route path="/sepet" element={<Cart />} />
                <Route path="/giris" element={<Login />} />
                <Route path="/kayit" element={<Register />} />
                <Route path="/profil" element={<Profile />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/siparis-basarili" element={<OrderSuccess />} />
                <Route path="/odeme-basarisiz" element={<PaymentFailed />} />
                <Route 
                  path="/admin" 
                  element={
                    <ProtectedRoute adminOnly>
                      <AdminPanel />
                    </ProtectedRoute>
                  } 
                />
                <Route path="/arama" element={<SearchResults />} />
                <Route path="/email-dogrulama-bekleniyor" element={<VerificationPending />} />
                <Route path="/email-dogrulama" element={<EmailVerification />} />
                <Route path="/sifremi-unuttum" element={<ForgotPassword />} />
                <Route path="/sifre-sifirlama" element={<ResetPassword />} />
                <Route path="/kullanim-kosullari" element={<TermsOfService />} />
                <Route path="/mesafeli-satis-sozlesmesi" element={<DistanceSalesAgreement />} />
                <Route path="/kvkk" element={<KVKKPolicy />} />
                <Route path="/hakkimizda" element={<AboutPage />} />
                <Route path="/iletisim" element={<Contact />} />
              </Routes>
            </main>
            
            <Footer />  {/* Footer'ı buraya ekleyin */}
            <WhatsAppButton />
          </div>
        </Router>
      </CartProvider>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;